import baseHttp from './baseHttp';

export const getMenus = (restaurantId) =>
  baseHttp.get(`/api/v1/restaurants/${restaurantId}/menus`).then((r) => r.data);

export const getCategories = (menuId) =>
  baseHttp.get(`/api/v1/menus/${menuId}/categories`).then((r) => r.data);

export const getProducts = (categoryId) =>
  baseHttp.get(`/api/v1/categories/${categoryId}/products`).then((r) => r.data);

export const getProductOptions = (productId) =>
  baseHttp.get(`/api/v1/products/${productId}/options`).then((r) => r.data);

export const toggleProduct = (productId, available) =>
  baseHttp.post(`/api/v1/products/${productId}/active`, { available: available ? 1 : 0 }).then((r) => r.data);

export const bulkToggleProducts = (products) =>
  baseHttp.post('/api/v1/products/active', { products }).then((r) => r.data);

// Set availability with optional auto-reactivation.
//   available=true                      → back in stock
//   available=false (no minutes)        → out indefinitely (86)
//   available=false + minutes           → out, auto-reactivates after N minutes
export const setProductAvailability = (productId, available, minutes) => {
  const body = { available: available ? 1 : 0 };
  if (!available && minutes) body.minutes = minutes;
  return baseHttp.post(`/api/v1/products/${productId}/availability`, body).then((r) => r.data);
};
